/* w3-stock-alert custom element.
   When the variant is unavailable, hide Stoq's ugly button while keeping
   it in the DOM, so that our own "CREATE AN ALERT" button can delegate
   its click to it (handled in component-custom-wishlist.js). */
!function () {
    class StockAlert extends HTMLElement {
        constructor() {
            super();
            this.el = this;
            this.variantAvailable = this.el.dataset.variantAvailable;
        }
        connectedCallback() {
            this.el = this;
            this.variantAvailable = this.el.dataset.variantAvailable;
            if (this.variantAvailable === 'false') {
                this.hideRestockButton();
            }
        }
        hideRestockButton() {
            // Keep the Restock Rocket button in DOM (so we can click it)
            // but hide it so our own button is the only visible one.
            const apply = () => {
                document.querySelectorAll('.restock-rocket-button-container').forEach(el => {
                    el.style.display = 'none';
                    el.style.visibility = 'hidden';
                    el.style.position = 'absolute';
                    el.style.left = '-9999px';
                    el.setAttribute('aria-hidden', 'true');
                });
            };
            apply();
            // Stoq may inject the container after page load; observe for it
            const observer = new MutationObserver(apply);
            observer.observe(document.body, { childList: true, subtree: true });
            // Stop observing after 10s
            setTimeout(() => observer.disconnect(), 10000);
        }
    }
    if (typeof customElements.get('w3-stock-alert') === 'undefined') {
        customElements.define('w3-stock-alert', StockAlert);
    }

    /* ===================================================================
       Auto-trigger the stock alert popup when arriving with ?stock_alert=1
       (clicked from an OOS quickbuy pill on the collection grid).
       Waits up to 6 seconds for the alert button (or the Restock Rocket
       button) to appear, then clicks it.
       =================================================================== */
    function autoTriggerStockAlert() {
        try {
            var params = new URLSearchParams(window.location.search);
            if (params.get('stock_alert') !== '1') return;
        } catch (e) { return; }

        var attempts = 0;
        var maxAttempts = 60; /* 6s total at 100ms */
        var poll = setInterval(function () {
            attempts++;
            /* Priority 1: theme's own create-alert button. */
            var themeBtn = document.querySelector('.product-form__create-alert-btn');
            if (themeBtn && themeBtn.offsetParent !== null) {
                clearInterval(poll);
                themeBtn.click();
                cleanUrl();
                return;
            }
            /* Priority 2: Restock Rocket / Stoq injected button. */
            var rrBtn = document.querySelector('.restock-rocket-button-container button, .restock-rocket-button-container a, .stoq-button, [data-stoq-trigger], [id*="stoq" i] button');
            if (rrBtn && rrBtn.offsetParent !== null) {
                clearInterval(poll);
                rrBtn.click();
                cleanUrl();
                return;
            }
            /* Priority 3: main product form's submit button when it's in
               "create alert" state (no available variant). */
            var formBtn = document.querySelector('#product-add-to-cart');
            if (formBtn && formBtn.offsetParent !== null && formBtn.classList.contains('product-form__create-alert-btn')) {
                clearInterval(poll);
                formBtn.click();
                cleanUrl();
                return;
            }
            if (attempts >= maxAttempts) clearInterval(poll);
        }, 100);
    }
    function cleanUrl() {
        try {
            var url = new URL(window.location.href);
            url.searchParams.delete('stock_alert');
            window.history.replaceState({}, '', url.toString());
        } catch (e) { /* noop */ }
    }
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', autoTriggerStockAlert);
    } else {
        autoTriggerStockAlert();
    }
}();
